var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"rowbg"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',[_c('b-card-title',[_vm._v("Videoclips")]),_c('silent-box',{staticClass:"galleryitems",attrs:{"gallery":_vm.galleryvideos}})],1),_c('b-card',[_c('b-card-title',[_vm._v("Foto's")]),_c('silent-box',{attrs:{"gallery":_vm.galleryimages}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }